/**
 * Class for simple manipulation with points in 2D space
 *
 * @class XY
 */
class XY {
  /**
   * Creates an instance of XY.
   *
   * @param {Number} x
   * @param {Number} y
   * @memberof XY
   */
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }

  /**
   * Returns a deep copy of the xy
   */
  copy() {
    return new XY(this.x, this.y);
  }

  /**
   * Adds xy to this point
   * @param {XY} xy
   */
  add(xy) {
    this.x += xy.x;
    this.y += xy.y;
    return this;
  }

  /**
   * Subtracts xy from this point
   * @param {XY} xy
   */
  subtract(xy) {
    this.x -= xy.x;
    this.y -= xy.y;
    return this;
  }

  /**
   * Scales this point by a scalar
   * @param {Number} a
   */
  scale(a) {
    this.x *= a;
    this.y *= a;
    return this;
  }

  /**
   * Adds two points and returns a new one
   * @static
   * @param {XY} xy1
   * @param {XY} xy2
   */
  static add(xy1, xy2) {
    return new XY(xy1.x + xy2.x, xy1.y + xy2.y);
  }

  /**
   * Subtracts xy2 from xy1 and returns a new point
   * @static
   * @param {XY} xy1
   * @param {XY} xy2
   */
  static subtract(xy1, xy2) {
    return new XY(xy1.x - xy2.x, xy1.y - xy2.y);
  }

  /**
   * Calculates the distance between two points
   * @static
   * @param {XY} xy1
   * @param {XY} xy2
   */
  static distance(xy1, xy2) {
    return Math.pow(Math.pow(xy1.x - xy2.x, 2) + Math.pow(xy1.y - xy2.y, 2), 0.5);
  }
}

export default XY;
